module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing__container"
  }, [_c('div', {
    staticClass: "landing__section"
  }, [_c('div', {
    staticClass: "landing__section-container"
  }, [_c('div', {
    staticClass: "landing__section-row"
  }, [_c('div', {
    staticClass: "landing__section-col-left"
  }, [_c('section-left')], 1), _vm._v(" "), _c('div', {
    staticClass: "landing__section-col-right"
  }, [_c('section-right')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "landing__section-row"
  }, [_c('div', {
    staticClass: "landing__section-col"
  }, [_c('offer-button')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e733669"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/components/Intro.vue
// module id = 43
// module chunks = 0